export type ScanHealthColorClass =
  | 'scan_health_none'
  | 'scan_health_3w'
  | 'scan_health_2w'
  | 'scan_health_1w'

export interface ScanDateImage {
  sub_point_id: number | string
  taken_on: string
}

export interface ScanDateFlatImage {
  sub_point_id: number
  taken_on: string
}

const startOfDay = (date: Date): Date => {
  const d = new Date(date)
  d.setHours(0, 0, 0, 0)
  return d
}

export const daysSinceScan = (
  lastScanDate: string,
  today = new Date(),
): number => {
  const scanDay = startOfDay(new Date(lastScanDate))
  const todayDay = startOfDay(today)
  const diffMs = todayDay.getTime() - scanDay.getTime()
  return Math.floor(diffMs / (1000 * 60 * 60 * 24))
}

export const getScanHealthColorClass = (
  lastScanDate: string | null,
  today = new Date(),
): ScanHealthColorClass => {
  if (!lastScanDate) {
    return 'scan_health_none'
  }

  const days = daysSinceScan(lastScanDate, today)

  if (days > 21) {
    return 'scan_health_none'
  }
  if (days <= 7) {
    return 'scan_health_1w'
  }
  if (days <= 14) {
    return 'scan_health_2w'
  }
  return 'scan_health_3w'
}

export const buildLastScanByPointId = (
  images: ScanDateImage[],
  flatImages: ScanDateFlatImage[] = [],
): Record<string, string> => {
  const lastScanByPointId: Record<string, string> = {}

  const considerDate = (pointId: string | number, takenOn: string) => {
    const key = String(pointId)
    const existing = lastScanByPointId[key]
    if (!existing || takenOn > existing) {
      lastScanByPointId[key] = takenOn
    }
  }

  images.forEach(image => {
    if (image.sub_point_id != null && image.taken_on) {
      considerDate(image.sub_point_id, image.taken_on.split('T')[0])
    }
  })

  flatImages.forEach(image => {
    if (image.sub_point_id != null && image.taken_on) {
      const datePart = image.taken_on.split('T')[0]
      considerDate(image.sub_point_id, datePart)
    }
  })

  return lastScanByPointId
}

export const formatScanHealthHoverLabel = (
  lastScanDate: string | null,
  today = new Date(),
): string => {
  if (!lastScanDate) {
    return 'Never scanned'
  }

  const formatted = new Date(lastScanDate).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })

  if (daysSinceScan(lastScanDate, today) > 21) {
    return `Last scanned: ${formatted}`
  }

  return `Last scanned: ${formatted}`
}
